import { render, staticRenderFns } from "./policiesregulations.vue?vue&type=template&id=35e8bba2&scoped=true&"
import script from "./policiesregulations.vue?vue&type=script&lang=js&"
export * from "./policiesregulations.vue?vue&type=script&lang=js&"
import style0 from "./policiesregulations.vue?vue&type=style&index=0&id=35e8bba2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8bba2",
  null
  
)

export default component.exports